/** Photographer profile/portfolio images may be a full external URL (legacy/seeded data) or an
 * internal object-storage path (new uploads) — this resolves either into a usable <img src>. */
export function mediaUrl(pathOrUrl) {
  if (!pathOrUrl) return null;
  if (pathOrUrl.startsWith("http://") || pathOrUrl.startsWith("https://")) return pathOrUrl;
  return `${process.env.REACT_APP_BACKEND_URL}/api/photographers/media/${pathOrUrl}`;
}
